import { useMemo } from 'react'
import { useController, useFormContext } from 'react-hook-form'

import { ToolConfig } from 'data/hooks/agents/types'
import { useObjects } from 'data/hooks/objects'

import { ItemSelectorItem } from 'ui/components/ItemSelector/types'

export function useToolInputTableAccessState() {
    const { control } = useFormContext<ToolConfig>()
    const { field, fieldState } = useController({
        name: 'supplied_settings.supplied_tables',
        control,
        rules: {
            required: 'At least one table must be selected',
        },
    })
    const error = fieldState.error

    const suppliedTables = useMemo(
        () => (Array.isArray(field.value) ? field.value : []),
        [field.value]
    )

    const { data: objects = [] } = useObjects()
    const tableOptions = mapObjectsToItemSelectorItems(objects)

    return useMemo(
        () => ({
            suppliedTables,
            tableOptions,
            error,
            onChange: field.onChange,
        }),
        [suppliedTables, tableOptions, error, field.onChange]
    )
}

function mapObjectsToItemSelectorItems(objects: ObjectDto[]): ItemSelectorItem[] {
    const items = objects.reduce((acc, object) => {
        if (!object.connection_options.read_only) {
            acc.push({
                label: object.name,
                value: object.slug,
                icon: { name: 'Table' },
            })
        }

        return acc
    }, [] as ItemSelectorItem[])

    return items.sort((a, b) => a.label.localeCompare(b.label))
}
